import { render, staticRenderFns } from "./VacationsApprove.vue?vue&type=template&id=56d03e84"
import script from "./VacationsApprove.vue?vue&type=script&lang=js"
export * from "./VacationsApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports